const getClassNames = className => {
    return className.split(' ').filter(function(value, index, self) { 
        return self.indexOf(value) === index;
    }).join(' ');
}

export default {
    getClassNames: getClassNames
};